import { Grid } from '@mui/material';

const Logos = () => {
	const subLogos = [
		'/assets/Images/logos/AltynRailSquare.jpg',
		'/assets/Images/logos/AltynMirasSquare.png',
		'/assets/Images/logos/AltynLogisticKZSquare.png',
		'/assets/Images/logos/AltynHayatSquare.png',
		'/assets/Images/logos/AltynAfghan.jpg',
		'/assets/Images/logos/AltynTechSquare.png',
	];
	return (
		<Grid
			display={'flex'}
			flexDirection={'column'}
			justifyContent={'center'}
			alignItems={'center'}
			gap={'25px'}
		>
			<Grid
				className="img-box"
				width={'250px'}
				height={'250px'}
				borderRadius={'50%'}
			>
				<img
					src="/assets/Images/company/group/logo.png"
					alt="Altyn Logo"
				/>
			</Grid>
			<Grid
				display={'flex'}
				alignItems={'center'}
				justifyContent={'center'}
				flexWrap={'wrap'}
				gap={'15px'}
			>
				{subLogos.map((logo, index) => (
					<Grid
						key={index}
						className="img-box"
						width={'150px'}
						height={'150px'}
						borderRadius={'50%'}
					>
						<img
							src={logo}
							alt="Logo"
						/>
					</Grid>
				))}
			</Grid>
		</Grid>
	);
};

export default Logos;
